const styles = theme => ({
  modal: {
    width: '100%',
    maxWidth: '840px',
    height: '95vh',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },

  content: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },

  pdfArea: {
    flex: 1,
    width: '100%',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    backgroundColor: theme.palette.primary.grey,
    padding: '2px',
  },

  actionsContainer: {
    width: '100%',
  },

  actionBtn: {
    flex: 1,
  },
});

export default styles;
